module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat3@3x-0320cbfb0fd27cca9b69a337988b422b.jpg";